"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightShipmentBillingStatus = void 0;
exports.FreightShipmentBillingStatus = {
    ERROR_NOT_BILLABLE: 'ERROR_NOT_BILLABLE',
    GENERATED: 'GENERATED',
    SENT_TO_BILLING: 'SENT_TO_BILLING',
    ERROR_SENDING_TO_BILLING: 'ERROR_SENDING_TO_BILLING',
    PENDING: 'PENDING',
    ERROR_NOT_ELIGIBLE: 'ERROR_NOT_ELIGIBLE'
};
//# sourceMappingURL=freight-shipment-billing-status.js.map